import { render, staticRenderFns } from "./conversation-list.vue?vue&type=template&id=4da2304b&scoped=true"
import script from "./conversation-list.vue?vue&type=script&lang=js"
export * from "./conversation-list.vue?vue&type=script&lang=js"
import style0 from "./conversation-list.vue?vue&type=style&index=0&id=4da2304b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2304b",
  null
  
)

export default component.exports